import {ItemsMenuAttrs, Section} from 'common/components/items-menu/types';
import {VisibilityChangeEvent} from 'common/components/base/stackable';

import {ButtonAttrs} from '../button';
import type {ChangeEvent as SelectChangeEvent, SelectAttrs} from '../select/types';
import type {TagItem} from './tag-item';

export enum TagInputTheme {
  Default = `default`,
  // This is a slight bastardization of the "tag-input". We need a lot of
  // similar functionality but it has nothing to do with "tags" conceptually,
  // but rather a path down a tree.
  Breadcrumbs = `breadcrumbs`,
  // To always render tags in "Light" Theme
  Light = `light`,
}

export enum TagInputChangeAction {
  Text = `text`,
  AddTag = `addTag`,
  RemoveTag = `removeTag`,
}

export type TagInputChangeEvent = CustomEvent<
  | {tag: TagItem; action: TagInputChangeAction.RemoveTag}
  | {tag: TagItem; action: TagInputChangeAction.AddTag}
  | {value: string; action: TagInputChangeAction.Text}
>;
export type TagInputClearEvent = CustomEvent<EmptyObj>;

export enum TagInputSearchMode {
  /** Input text is used to filter tag menu */
  Text = `text`,
  /** Splits input text into words. If the last word is prefixed with "#", it is used to filter tag menu */
  Hashtag = `hashtag`,
}

export type TagInputJsxProps = {
  attrs?: {
    error?: boolean;
    'min-tags'?: number;
    'show-search-icon'?: boolean;
    'show-clear'?: boolean;
    tags?: TagItem[];
    placeholder?: string;
    'disable-input'?: boolean;
    'mp-select-attrs'?: SelectAttrs;
    'mp-button-attrs'?: ButtonAttrs;
    theme?: TagInputTheme;
    'search-mode'?: TagInputSearchMode;
    'mp-items-menu-attrs'?: ItemsMenuAttrs;
  };
  props?: {
    value: string;
    /** if specified, will render a menu of tags to select from */
    tagMenuSections?: Array<Section<TagItem>>;
  };
  on?: {
    optionSelected?: (ev: SelectChangeEvent<TagItem>) => void;
    change?: (ev: TagInputChangeEvent) => void;
    clear?: (ev: TagInputClearEvent) => void;
    tagMenuChange?: (ev: VisibilityChangeEvent) => void;
  };
};

export type TagMenuState = {
  sections: Array<Section<TagItem>>;
  isOpen: boolean;
};

export type TagInputState = {
  isInputFocused: boolean;
  inputText: string;
  inputWidth: string;
  tagMap: Map<string, TagItem>;
  searchInputEl?: HTMLElement;
  tagMenu?: TagMenuState;
};
